export interface User {
  id: string;
  phone: string;
  first_name: string | null;
  last_name: string | null;
  birthday?: string | null;
  email?: string | null;
  role: string;
}

export function isProfileComplete(user: User | null): boolean {
  if (!user) return false;
  
  // Check if required fields are present and not empty
  const hasFirstName = Boolean(user.first_name && user.first_name.trim() !== '');
  const hasLastName = Boolean(user.last_name && user.last_name.trim() !== '');
  const hasBirthday = Boolean(user.birthday && user.birthday.trim() !== '');
  
  return hasFirstName && hasLastName && hasBirthday;
}

export function getMissingProfileFields(user: User | null): string[] {
  if (!user) return ['first_name', 'last_name', 'birthday'];
  
  const missing: string[] = [];
  
  if (!user.first_name || user.first_name.trim() === '') {
    missing.push('first_name');
  }
  
  if (!user.last_name || user.last_name.trim() === '') {
    missing.push('last_name');
  }
  
  if (!user.birthday || user.birthday.trim() === '') {
    missing.push('birthday');
  }
  
  return missing;
}

/**
 * Pages the global complete-profile modal leaves alone: planner pages (/p/<slug>) ask only for a name at checkout,
 * and the brand page's booking wizard (/book/<brand>, and the vendor's private link /book-external/<vendor>) asks
 * for the profile itself on its last step, before the order. The payment pages (/book-external/payment/…) stay covered.
 */
export function isProfileModalExempt(pathname: string): boolean {
  return /^(\/[a-z]{2})?\/(p\/|book\/|book-external\/(?!payment(\/|$)))/.test(pathname || '');
}
